module.exports = __webpack_public_path__ + "media/images/icon-close-ecd56bda6b02948068a340aa709669a2.svg";